import React, { useCallback, useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, Icon, Dropdown, Button } from 'antd';
import { DropDownContainer, MenuItem } from './styles';
import { fetchUserDetails } from '../../utils/services/authAPI';
import { updateLanguagePreference } from '../../utils/services/languageApi';
import { AppStoreContext } from '../../context/appStoreContext';
import axios from 'axios';
import { tolgeeInitOptions } from '../../i18n';

const ChangelangTolgee = () => {
  const { i18n } = useTranslation();
  const { userDetails, setUserDetails } = useContext(AppStoreContext);
  const [languages, setLanguages] = useState();

  useEffect(() => {
    (async () => {
      const path = `${tolgeeInitOptions.apiUrl}v2/projects/${tolgeeInitOptions.projectId}/languages`;
      const response = await axios.get(path, {
        headers: { 'x-api-key': tolgeeInitOptions.apiKey },
      });
      setLanguages(response?.data?._embedded?.languages);
    })();
  }, []);

  useEffect(() => {
    if (userDetails && userDetails.languageCode && userDetails.languageCode !== '') {
      i18n.changeLanguage(userDetails.languageCode);
    }
  }, [userDetails]);

  const changeLanguage = async lng => {
    i18n.changeLanguage(lng);
    let response = await updateLanguagePreference(lng);
    if (response && response?.errors?.length === 0) {
      const res = await fetchUserDetails();
      if (res && res.data) {
        setUserDetails(res.data);
      }
    }
  };

  const menu = useCallback(() => {
    return (
      <Menu>
        {languages?.map((keyName, i) => (
          <Menu.Item onClick={() => changeLanguage(keyName.tag)}>
            <MenuItem active={keyName.tag === i18n.language}>
              {keyName.originalName}
              {keyName.tag === i18n.language && <Icon type="check" />}
            </MenuItem>
          </Menu.Item>
        ))}
      </Menu>
    );
  }, [languages, i18n.language]);

  return (
    <DropDownContainer>
      <Dropdown overlay={menu}>
        <Button>
          {i18n.language} <Icon type="global" /> <Icon type="down" />
        </Button>
      </Dropdown>
    </DropDownContainer>
  );
};

export default ChangelangTolgee;
